import * as env from "lib/environment"
import { ReleaseReadModel } from "featureFlags/domain/release"
import { BrowserStorageFactory } from "featureFlags/infrastructure/browserStorage"
import { CombinedSourcesReleaseReadModel } from "featureFlags/infrastructure/releaseSources"

export class ReleaseReadModelFactory {
  build = (): ReleaseReadModel =>
    new CombinedSourcesReleaseReadModel(
      new BrowserStorageFactory().build(),
      env
    )
}
